import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private modalCtrl: ModalController) {}

  async openModal(component: any, props: any): Promise<any> {
    const modal = await this.modalCtrl.create({
      component,
      componentProps: {
        data: props,
      },
      cssClass: 'modal-full',
      animated: false,
    });

    // Modal anzeigen
    await modal.present();

    // Warten, bis das Modal geschlossen wird, und Rückgabewerte holen
    const { data } = await modal.onDidDismiss();
    return data;
  }

}
